export default __webpack_public_path__ + "static/dumpster-rental-b60da4f1c8dd293305906696f7291566.jpg";